import { User } from '../pages/UserProfile/userProfileSlice';

export default function displayRemovedUser(userId: number, user?: User) {
  return user
    ? `${user?.firstName} ${user?.lastName}`
    : `Removed User ${userId}`;
}
